import axios from 'axios';

const loadAbort = () => {
  return new AbortController();
};

export const getTransactionSalesListEndpoint = (
  query: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/ts/v1/admin/transaction-sales${query}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getTransactionSalesPaymentDetailEndpoint = (
  id: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/ts/v1/admin/transaction-sales/${id}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getTransactionSaleQuotaDetailEndpoint = (
  transactionSaleId: string,
  transactionDetailId: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/ts/v1/admin/transaction-sales/${transactionSaleId}/transaction-detail/${transactionDetailId}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const unselectTransactionSalesEndpoint = (
  transactionId: any,
  token: string,
) => {
  const controller = loadAbort();

  return {
    call: (urlService: string) =>
      axios({
        method: 'delete',
        url: `${urlService}/ts/v1/admin/transaction-sales/${transactionId}/unselect`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getQuotaPreviewCheckoutEndpoint = (
  transactionSaleId: string,
  transactionDetailId: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/ts/v1/admin/transaction-sales/${transactionSaleId}/transaction-detail/${transactionDetailId}/checkout-preview`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};
